import wixUsers from 'wix-users';
import wixLocation from 'wix-location';

let user = wixUsers.currentUser;

$w.onReady(function () {
    
});


export function wishListIcon_click(event, $w) {
    if (user.loggedIn) {
        wixLocation.to("/account/wish-list")
    } else {
        loginFavouritesClick();
    } 
}


async function loginFavouritesClick() {
    console.log("loginFavouritesClick")
    let options = {"mode": "login"};
    await wixUsers.promptLogin(options);
}

export function wishListIcon_mouseIn(event, $w) {
    $w('#wishListMessage').show();
}

export function wishListIcon_mouseOut(event, $w) {
    $w('#wishListMessage').hide();
}
